<div id="cart-abandonment-warning-div" class="text-center" tabindex="50" appFocusable>
  <h3>
    If you proceed, your cart will be emptied. Do you want to proceed?
  </h3>
  <button class="btn btn-primary" (click)="allowAbandonment()">Proceed anyway</button>
  <button class="btn btn-primary" (click)="goToCart()">Go to the cart instead</button>
</div>



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/cart/cart-abandonment-warning/cart-abandonment-warning.component.html